import React from 'react';
import classNames from 'classnames';

import {ErrorField} from 'components/Fields';
import emailIcon from './assets/email-icon.svg';

import './styles.css';

const EmailField = ({
  input: {onChange, onBlur, value},
  placeholder,
  className,
  disabled,
  meta: {touched, error}
}: any) => {
  return (
    <div className="EmailField">
      <div className="inputWrapper">
        <div className="icon">
          <img src={emailIcon} alt="Email icon" />
        </div>
        <input
          onChange={onChange}
          onBlur={onBlur}
          className={classNames({error: touched && error, disabled}, className)}
          placeholder={placeholder}
          type="email"
          value={value}
          disabled={disabled}
        />
      </div>
      <ErrorField touched={touched} error={error} />
    </div>
  );
};

export default EmailField;
